import React, { useState } from "react";
import SidemenuItem from "./SidemenuItem";
import { IoCloseCircleOutline } from "react-icons/io5";

import PharmacyLogo from "../assets/rxultimate.png";

import {
  superadminMenuItems,
  menuItems,
  employeeMenuItems,
  alphaMenuItems,
  alphaEmployeeMenuItems,
  compactEmployeeMenuItems,
  compactMenuItems,
  alphaCashierMenuItems,
  compactCashierMenuItems,
  cashierMenuItems,
} from "../utils/userRoutes";
import { useAuthenticate } from "../context/AuthContext";

const Sidebar = ({ openSidebar, setOpenSidebar }) => {
  const { user, subscriptionDetails } = useAuthenticate();
  const [openSubmenuIndex, setOpenSubmenuIndex] = useState(null);

  
  const getMenuItems = () => {
    
    if (user?.is_superuser) {
      return superadminMenuItems;
    }

    
    if (!subscriptionDetails?.success) {
      return [];
    }

    const packageType = subscriptionDetails?.subscription?.package;
    const isCashier = user?.position === "Cashier";

    // Pharmacy admin menu items based on package
    if (user?.is_pharmacy_admin) {
      switch (packageType) {
        case "Alpha":
          return alphaMenuItems;
        case "Compact":
          return compactMenuItems;
        default:
          return menuItems; // Professional package and free trial package
      }
    }

    // Employee menu items based on package and position
    if (user?.is_employee) {
      if (isCashier) {
        switch (packageType) {
          case "Alpha":
            return alphaCashierMenuItems;
          case "Compact":
            return compactCashierMenuItems;
          default:
            return cashierMenuItems; // Professional package
        }
      } else {
        switch (packageType) {
          case "Alpha":
            return alphaEmployeeMenuItems;
          case "Compact":
            return compactEmployeeMenuItems;
          default:
            return employeeMenuItems; // Professional package
        }
      }
    }

    return [];
  };

  const handleSubmenuToggle = (index) => {
    // If clicking the same item, close it. Otherwise, open the new one and close others
    setOpenSubmenuIndex(openSubmenuIndex === index ? null : index);
  };

  const menuItemsToRender = getMenuItems();

  return (
    <aside
      style={{ marginLeft: openSidebar ? "0" : "-16.25rem" }}
      className="js-navbar-vertical-aside navbar navbar-vertical-aside navbar-vertical navbar-vertical-fixed navbar-expand-xl navbar-bordered"
    >
      <div className="navbar-vertical-container text-capitalize">
        <div className="navbar-vertical-footer-offset">
          <div className="navbar-brand-wrapper justify-content-between">
            <div className="flex items-center mr-5" aria-label="Front">
              <img className="side-logo" src={PharmacyLogo} alt="Logo" />
              <span className="sidebar-close-icon">
                <IoCloseCircleOutline
                  className="ml-5"
                  onClick={() => setOpenSidebar(!openSidebar)}
                />
              </span>
            </div>
          </div>
          
          <div className="navbar-vertical-content" id="navbar-vertical-content">
            <ul className="navbar-nav navbar-nav-lg nav-tabs mt-3">
              {menuItemsToRender.map((menuItem, index) => (
                <SidemenuItem
                  menuItem={menuItem}
                  key={`${menuItem.path || menuItem.name}-${index}`}
                  submenus={menuItem?.submenus}
                  isOpen={openSubmenuIndex === index}
                  onToggle={() => handleSubmenuToggle(index)}
                />
              ))}
            </ul>
          </div>
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;